// extracted by mini-css-extract-plugin
export default {"bookingDateInput":"BookingDatePicker_bookingDateInput__9Zulu","calendarIcon":"BookingDatePicker_calendarIcon__V6hxh"};